"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewModbusModel extends new_item_1.default {
    constructor(newModbusModel) {
        super();
        this.displayName = newModbusModel.displayName;
        this.modbusDeviceType = newModbusModel.modbusDeviceType;
        this.modbusManufacturerName = newModbusModel.modbusManufacturerName;
        this.modbusProductName = newModbusModel.modbusProductName;
        this.sku = newModbusModel.sku;
        this.manufacturerSku = newModbusModel.manufacturerSku;
        this.displayImage = newModbusModel.displayImage;
        this.parity = newModbusModel.parity;
        this.baudRate = newModbusModel.baudRate;
        this.stopBits = newModbusModel.stopBits;
        this.dataBits = newModbusModel.dataBits;
        this.rxTimeout = newModbusModel.rxTimeout;
        this.registers = newModbusModel.registers;
        this.readOnly = newModbusModel.readOnly;
        this.organisationId = newModbusModel.organisationId;
        this.global = newModbusModel.global;
        this._permission = newModbusModel._permission;
    }
}
exports.default = NewModbusModel;
//# sourceMappingURL=new-modbusModel.js.map